function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgVanUtilitario = function SvgVanUtilitario(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.732a1 1 0 00-1 1v12.373c0 .093.065.18.165.203l2.46.318a3.453 3.453 0 013.39-2.758c1.7 0 3.12 1.22 3.406 2.832h11.474a3.452 3.452 0 013.405-2.832c1.7 0 3.119 1.22 3.405 2.832h2.016c.056 0 .11-.007.163-.02a.025.025 0 00.013-.008.188.188 0 00.038-.055.798.798 0 00.065-.34V11.07c0-.17-.017-.339-.05-.504h-5.245a.6.6 0 01-.332-.1l-2.3-1.528h-3.908a.6.6 0 01-.6-.6V1.732H3zm0-1.2a2.2 2.2 0 00-2.2 2.2v12.373a1.411 1.411 0 001.19 1.39l2.61.338a3.45 3.45 0 003.416 2.899c1.699 0 3.118-1.22 3.405-2.832h11.474a3.452 3.452 0 003.405 2.832c1.7 0 3.119-1.22 3.405-2.832h2.016c.16 0 .316-.02.467-.06.41-.107.672-.39.82-.686.142-.285.192-.602.192-.878v-4.205a3.8 3.8 0 00-.808-2.343l-5.755-7.352a2.2 2.2 0 00-1.733-.844H3zm17.765 1.2v6.007h1.27V5.534a.6.6 0 111.2 0V7.74h1.02a.6.6 0 01.332.1l2.3 1.528h4.481l-5.676-7.252a1 1 0 00-.788-.383h-4.14zm-1.2 8.715a.6.6 0 01.6-.6h1.239a.6.6 0 110 1.2h-1.24a.6.6 0 01-.6-.6zm-11.55 3.621c-1.251 0-2.257 1.005-2.257 2.232 0 1.227 1.006 2.232 2.258 2.232s2.257-1.005 2.257-2.232c0-1.227-1.005-2.232-2.257-2.232zm18.285 0c-1.252 0-2.257 1.005-2.257 2.232 0 1.227 1.005 2.232 2.257 2.232 1.252 0 2.258-1.005 2.258-2.232 0-1.227-1.006-2.232-2.258-2.232z",
    fill: props.color
  }));
};
SvgVanUtilitario.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgVanUtilitario.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgVanUtilitario;